export const isStaging = () =>
	window.location?.host === "sso-staging.cosmogas.com";
